import React from 'react';

export const YearHeader = ({children, textcolor = ''}) => {
    return <h4 className={`d-flex justify-content-center mb-3 mt-2 ${textcolor}`}>{children}</h4>;
};